import type { HTMLAttributes } from "react";
import styled from "styled-components";
import NafLogo from "../../logos/NafLogo";

const Wrapper = styled.div`
  background-color: white;
  z-index: 2;
`;

const HeaderRoot = styled.div`
  min-height: 2em;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const OuterHeader = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1440px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  padding: 16px;

  @media screen and (min-width: 720px){
    padding: 24px 24px;
  }
`;

const LogoHeaderSection = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: auto;

  @media screen and (min-width: 720px){
    width: 40%;
  }
`;

export default function StandaloneHeader(
  props: HTMLAttributes<HTMLDivElement>,
) {
  const { className } = props;
  return (
    <Wrapper {...props}>
      <HeaderRoot className={className}>
        <OuterHeader>
          <HeaderWrapper>
            <LogoHeaderSection>
              <NafLogo size={56} />
            </LogoHeaderSection>
          </HeaderWrapper>
        </OuterHeader>
      </HeaderRoot>
    </Wrapper>
  );
}
